import { memo, useContext } from 'react';

import PersonInPlaceEditor from '@/components/PersonInPlaceEditor';
import { FieldTypes } from '@/components/PersonInPlaceEditor/types';
import PersonContext from '@/pages/Person/PersonContext';
import { appLoginEmailSchema } from '@/pages/Profile/schemas';
import DataList, { DataRow } from '@/ui/components/DataList';
import Heading from '@/ui/components/Heading';

const AppLoginEmailSection = () => {
  const { person } = useContext(PersonContext);

  return (
    <div className="group/subsection mb-4 relative">
      <Heading className="mb-2" value={4} text="" />
      <PersonInPlaceEditor
        subsectionEditor
        schema={appLoginEmailSchema}
        fields={[
          {
            key: 'app_login_email',
            label: 'App Login Email',
            type: FieldTypes.TEXT
          }
        ]}>
        <DataList>
          <DataRow
            label="App Login Email"
            tooltipContent="The member's login email is used to sign in. We'll also send account recovery emails to this address.">
            {person.app_login_email ? (
              <a
                className="inline-block overflow-hidden text-ellipsis text-blue-600 w-full"
                target="_blank"
                rel="noreferrer"
                href={`mailto:${person.app_login_email}`}>
                {person.app_login_email}
              </a>
            ) : (
              'No app login email set'
            )}
          </DataRow>
        </DataList>
      </PersonInPlaceEditor>
    </div>
  );
};

export default memo(AppLoginEmailSection);
